export default "__VITE_ASSET__DIiLVA58__"